<template>
  <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
    >
      <slot name="body">
          
        <div class="">
          
          <validation-observer ref="branchValidation">
            <b-form @submit.prevent="onSubmit">
              <b-row>
                <b-col cols="12">

                  <form-select
                    label="نوع الجهة الشريكة"
                    id="attendance-time"
                    :options="[{id : 'governmental' , name_ar : 'حكومية' },{id : 'spiritual' , name_ar : 'روحية' }, {id : 'ngo' , name_ar : 'منظمة غير حكومية' },{id : 'private' , name_ar : 'خاصة' }]"
                    rules="required"
                    v-model="form.partner_entity"
                    :getOptionLabel="(x) => x.name_ar"
                    :reduce="(x) => x.id"
                  />
                </b-col>
                
                <b-col cols="12">
                  
                  <form-input
                    label="اسم الجهة الشريكة"
                    v-model="form.partner_entity_name"
                    rules="required"
                  />
                </b-col>
                
                <b-col cols="12">
                  
                  <form-input
                    label="مدة التعاون(بالأشهر)"
                    v-model="form.duration"
                    rules="required|integer"
                    placeholder="3"
                  />
                </b-col>
                <b-col cols="12">
                  <b-form-group label="هدف التعاون" label-for="details">
                    <validation-provider
                      #default="{ errors }"
                      name="هدف التعاون"
                      rules="required"
                      id="details"
                      mode="passive"
                    >
                      <quill-editor
                        :options="editorOption"
                        v-model="form.goal_of_cooperation"
                        :class="{ quillEditor: errors.length > 0 }"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col>
                  <form-file-input
                    placeholder="اختر ملفاً"
                    id="document"
                    label="وثيقة التعاون"
                    accept="application/pdf"
                    v-model="form.file"
                    rules="required"
                  />
                </b-col>
              </b-row>
              <hr />

              <b-row class="px-1 justify-content-end">
                <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
                <save-btn
                  type="submit"
                  variant="success"
                  :loading="loading"
                  :label="btnLabel"
                >
                </save-btn>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
          </slot>
    </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import "quill/dist/quill.snow.css";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
 
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
